import { checkFileTypeByFileName, FileType } from '../check-file-type'
import { showMediaImageWindow } from './showMediaImageWindow'
import { showMediaPdfWindow } from './showMediaPdfWindow'

export const showMediaWindow = (mediaFileUrl: string, fileName?: string): void => {
  const mediaFileName = fileName || mediaFileUrl

  if (checkFileTypeByFileName(mediaFileName) === FileType.IMAGE) {
    showMediaImageWindow(mediaFileUrl)
  }
  if (checkFileTypeByFileName(mediaFileName) === FileType.PDF) {
    showMediaPdfWindow(mediaFileUrl)
  }
}
